import { api } from "@/openapi/client";
import { operations } from "@/openapi/generated";
import { ApiResponseError } from "@/lib/error";
import { getCacheTags } from "@/lib/cache-utils";
import { releaseNoteQueryKeys } from "@/app/[locale]/release-notes/_api/release-note-query-keys";

// Type exports from OpenAPI
export type GetReleaseNotesRequestParameter = operations["getReleaseNotes"]["parameters"]["query"];
export type GetReleaseNotesResponse = operations["getReleaseNotes"]["responses"]["200"]["content"]["*/*"];
export type GetReleaseNoteBySlugResponse = operations["getReleaseNoteBySlug"]["responses"]["200"]["content"]["*/*"];
export type GetAvailableCategoriesResponse = operations["getAvailableCategories"]["responses"]["200"]["content"]["*/*"];

/**
 * Get paginated list of release notes with filtering options
 */
export async function getReleaseNotes(query: GetReleaseNotesRequestParameter = {}): Promise<GetReleaseNotesResponse> {
  const { data, error } = await api.GET("/release-notes", {
    params: { query },
    next: { tags: getCacheTags(releaseNoteQueryKeys.list(query)) }
  });
  
  if (error) throw error;
  if (!data) throw new ApiResponseError("getReleaseNotes");
  
  return data;
}

/**
 * Get single release note by slug
 */
export async function getReleaseNoteBySlug(slug: string): Promise<GetReleaseNoteBySlugResponse> {
  const { data, error } = await api.GET("/release-notes/{slug}", {
    params: { path: { slug } },
    next: { tags: getCacheTags(releaseNoteQueryKeys.detail(slug)) }
  });
  
  if (error) throw error;
  if (!data) throw new ApiResponseError("getReleaseNoteBySlug");
  
  return data;
}

/**
 * Get all available release note categories
 */
export async function getAvailableCategories(): Promise<GetAvailableCategoriesResponse> {
  const { data, error } = await api.GET("/release-notes/categories", {
    next: { tags: getCacheTags(releaseNoteQueryKeys.categories()) }
  });
  
  if (error) throw error;
  if (!data) throw new ApiResponseError("getAvailableCategories");
  
  return data;
}